import React, { useCallback } from 'react'
import { TopSubmenu } from '@shared/components/top-menu/shared/menu-list/submenu'
import { topMenuItems } from '@shared/menu-items/top-menu-items'
import { ExternalPaths } from '@shared/menu-items/paths'
import ArrowSVG from '@shared/svg/arrow.svg'
import { isClient } from '@shared/utils/is-client'
import cx from 'classnames'
import Link from 'next/link'

import { IStateProps } from './model'

import styles from './style.module.scss'

export const View = ({ activeItem, setActiveItem, pathname = '', className }: IStateProps) => {
	const setActiveSubmenuItem = (
		e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
		name: string
	) => {
		e.preventDefault()
		setActiveItem(name)
	}

	return (
		<nav className={styles.nav}>
			{topMenuItems.map(({ path, name, items }, i) => {
				const hasSubmenu = !!items?.length
				const showSubmenu = activeItem === name

				const dataAttr = hasSubmenu
					? {
							'data-submenu-active': showSubmenu,
					  }
					: {}

				const isActiveRoute = (path) => path === `/${pathname.split('/')[1]}`

				return (
					<div {...dataAttr} key={`${name}-${i}`} className={cx(styles.navItemWrap, className)}>
						<div className={styles.navItem}>
							{hasSubmenu ? (
								<Link href={path!} onMouseEnter={(e) => setActiveSubmenuItem(e, name)}>
									<span
										role='menubutton'
										className={cx(styles.navWithSubmenu, {
											[styles.navActive]: isActiveRoute(path),
										})}
									>
										{name}
										<ArrowSVG className={styles.arrow} />
									</span>
								</Link>
							) : path === ExternalPaths.invest ? (
								<a href={path}>
									<span
										className={cx({
											[styles.navActive]: isActiveRoute(path),
										})}
									>
										{name}
									</span>
								</a>
							) : (
								<Link
									href={path!}
									target={name === 'Банкам' ? '_blank' : '_self'}
									rel={name === 'Банкам' ? 'noopener noreferrer nofollow' : undefined}
								>
									<span
										className={cx({
											[styles.navActive]: isActiveRoute(path),
										})}
									>
										{name}
									</span>
								</Link>
							)}
						</div>
						{showSubmenu && <TopSubmenu setActiveItem={setActiveItem} items={items} />}
						{!isClient && hasSubmenu && (
							<nav hidden>
								{items!.map(({ name, path }, i) => (
									<a key={`${name}-${i}`} href={path}>
										{name}
									</a>
								))}
							</nav>
						)}
					</div>
				)
			})}
		</nav>
	)
}
